import { render } from "./UploadItem.vue?vue&type=template&id=c35c8ad6&scoped=true"
import script from "./UploadItem.vue?vue&type=script&lang=js"
export * from "./UploadItem.vue?vue&type=script&lang=js"

import "./UploadItem.vue?vue&type=style&index=0&id=c35c8ad6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c35c8ad6"]])

export default __exports__